<template>
	<LayoutFormInputGeneral :inputId="inputId" :title="title" :subtitle="subtitle" :info="info" :validation="validation">
		<div class="form-check" :class="{'form-check-inline': (type == 'inline'), 'is-invalid': validation?.$error}" v-for="(text, index) in optionsFiltereds" v-bind:key="index">
			<input type="checkbox"
					:id="`${inputId}-${index}`"
					:value="index"
					v-model="inputValue"
					@change="emitInput"
					class="form-check-input"
					:class="{'is-invalid': validation?.$error}">
			<label :for="`${inputId}-${index}`" class="form-check-label" v-html="text"></label>
		</div>
	</LayoutFormInputGeneral>
</template>

<script>
	import { ref, computed } from 'vue';
	import _ from 'lodash';

	export default {
		emits: ['update:modelValue'],
		props: {
			modelValue: {
				type: Object,
				default: []
			},
			title: String,
			subtitle: String,
			info: String,
			validation: Object,
			options: {
				type: Object,
				default: {}
			},
			optionsType: {
				type: String,
				default: 'flat'
			},
			type: String
		},
		setup(props, { emit }) {
			const inputId = `input-${Math.random().toString(36).substr(2, 9)}`;
			const inputValue = ref(props.modelValue);
			const optionsFiltereds = computed(() => {
				switch(props.optionsType) {
					case 'advance':
						return _.mapValues(props.options, 'description');
						break;
					default:
						return props.options;
						break;
				}
			});

			const emitInput = (event) => {
				emit('update:modelValue', inputValue.value);
			};

			return { inputId, inputValue, optionsFiltereds, emitInput };
		}
	}
</script>